import MyModal from "src/components/layout/MyModal";
import PropTypes from "prop-types";
import Report_Settings from "./Report_Settings";

export default function Report_SettingsModal({ isOpen, setIsOpen }) {
  return (
    <MyModal
      buttonSize="small"
      title="Raportti ulkoasu- ja tulostusasetukset"
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      fullWidth={true}>
      <div style={{ paddingLeft: 16, paddingRight: 16 }}>
        <Report_Settings />
      </div>
    </MyModal>
  );
}

Report_SettingsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
};
